<template>
  <div>
    <v-data-iterator :items="getOnAttempts" :loading="getOnAttemptsLoading" :server-items-length="Number(getOnAttemptsConfig.paginationCount)" :page.sync="options.pagination.page" :options.sync="options.pagination" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">
      <template v-slot:default="{ items }">
        <v-row>
          <v-col cols="12" v-for="{ id, files } in items" :key="id">
            <v-card class="mb-2">
              <v-card-title>Attempt {{ id }}
                <v-spacer></v-spacer>

                <div>
                  <v-btn small color="primary" class="mr-1" @click="openUploadAuddis(id)">
                    <v-icon>{{ icons.mdiUpload }}</v-icon>AUDDIS
                  </v-btn>
                  <v-btn small color="primary" @click="openUploadAllEntries(id)">
                    <v-icon>{{ icons.mdiUpload }}</v-icon>ALL ENTRIES
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text>
                <v-data-table :headers="fileHeaders" :items="files" :options="{itemsPerPage: files.length}" hide-default-footer>
                  <template v-slot:item.last_changed="{ item }">{{ item.last_changed | formatDate }}</template>
                  <template v-slot:item.user_sid="{ item }">{{ item.user_sid | customPlaceholder('-') }}</template>
                  <template v-slot:item.file_type="{ item }">{{ item.file_type | customPlaceholder('-') }}</template>
                  <template v-slot:item.file_name="{ item }">{{ item.file_name | customPlaceholder('-') }}</template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn small color="primary" :loading="getDownloadOnAttemptsLoadingById(item.id)" @click="downloadFile({ id, fileId: item.id, fileType: item.file_type, fileName: item.file_name })">
                      <v-icon>{{ icons.mdiDownload }}</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>   
    </v-data-iterator>
    
    <UploadAuddisDialog v-model="auddisOpen" />
    <UploadAllEntriesDialog v-model="allEntriesOpen" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { mdiDownload, mdiUpload  } from '@mdi/js';

import UploadAllEntriesDialog from './UploadAllEntriesDialog';
import UploadAuddisDialog from './UploadAuddisDialog';

export default {
  components: { UploadAllEntriesDialog, UploadAuddisDialog },

  data() {
    return {
      icons: {
        mdiDownload,
        mdiUpload 
      },
      fileHeaders: [
        { text: 'Last updated', sortable: false, value: 'last_changed' },
        { text: 'User', sortable: false, value: 'user_sid' },
        { text: 'File Type', sortable: false, value: 'file_type' },
        { text: 'File Name', sortable: false, value: 'file_name' },
        { text: 'Actions', sortable: false, value: 'actions' },
      ],
      options: {
        pagination: {
          page: 1,
          itemsPerPage: 50,
          sortBy: [],
          sortDesc: [],
        },
        queryParams: {},
      },
      itemsPerPageOptions: [5,10,15,25,50],
      auddisOpen: false,
      allEntriesOpen: false
    }
  },

  computed: {
    ...mapGetters('ledger/OnDashboard', ['getOnAttempts', 'getOnAttemptsLoading', 'getOnAttemptsConfig', 'getDownloadOnAttemptsLoadingById']),
    ...mapGetters('ledger', ['hasUserGotRoles']),
  },

  watch: {
    "options.pagination": {
      immediate: false,
      handler() {
        const query = {
          pagination: {
            page: this.options.pagination.page,
            limit: this.options.pagination.itemsPerPage,
          },
          queryParams: { ...this.options.queryParams }
        };
        this.updateOnAttemptsConfigPagination(query);
        if(this.options.queryParams) {
          delete this.options.queryParams;
        }
      },
      deep: true,
    }
  },

  async created() {
    await this.fetchLedgerUser();
    
    const queryParams = JSON.parse(JSON.stringify(this.$route.query));
    
    if(Object.keys(queryParams).length) {
      this.options.pagination.page = parseInt(queryParams.page);
      this.options.pagination.itemsPerPage = parseInt(queryParams.limit);
      this.options.pagination.sortBy = queryParams.ordering ? [queryParams.ordering] : [];
      this.options.pagination.sortDesc = queryParams.order === 'asc' ? [false] : queryParams.order === 'desc' ? [true] : [true];
      this.options.queryParams = { ...queryParams };
    } else {
      this.options.page = 1;
      this.options.pagination.itemsPerPage = 50;
      this.options.pagination.sortDesc = [true];
    }
  },

  beforeDestroy() {
    this.RESET_ON_ATTEMPTS_STORE();
  },

  methods: {
    ...mapActions('ledger', ['fetchLedgerUser']),
    ...mapActions('ledger/OnDashboard', ['updateOnAttemptsConfigPagination', 'downloadOnAttempts']),
    ...mapActions('alerts', ['setAlert']),
    ...mapMutations('ledger/OnDashboard', ['RESET_ON_ATTEMPTS_STORE', 'SET_ATTEMPT_ID']),

    async downloadFile(data) {
      await this.downloadOnAttempts(data);
    },

    openUploadAuddis(id) {
      if (this.hasUserGotRoles(['can-create-dd-runs-attempts-and-files'])) {
        this.SET_ATTEMPT_ID(id);
        this.auddisOpen = true;
      } else {
        this.setAlert({ type: 'error', message: 'You do not have permission to carry out this action' });
      }   
    },

    openUploadAllEntries(id) {
      if (this.hasUserGotRoles(['can-create-dd-runs-attempts-and-files'])) {
        this.SET_ATTEMPT_ID(id);
        this.allEntriesOpen = true;
      } else {
        this.setAlert({ type: 'error', message: 'You do not have permission to carry out this action' });
      }   
    }
  }
}
</script>

<style lang="scss" scoped>
</style>